import React from 'react';
import { compose } from 'redux';
import { useIntl } from 'react-intl-next';
import { withOnlyJiraAdmin } from 'view/common/with-only-jira-admin';
import { withOnlyLoggedIn } from 'view/common/with-only-logged-in';
import { authPageMessage, callToActionUrlText } from 'view/portal-reorder-experience';

export interface Props {
    children: React.ReactNode;
}

export const JiraAdminPermissionWrapper = ({ children }: Props) => {
    const { formatMessage } = useIntl();
    const WrappedComponent = compose(
        withOnlyLoggedIn({
            redirectUrl: '/',
        }),
        withOnlyJiraAdmin({
            message: formatMessage(authPageMessage),
            callToActionText: formatMessage(callToActionUrlText),
            callToActionUrl: '/portals',
        })
    )(() => React.Children.only(children));
    return <WrappedComponent />;
};
